import React, { lazy, Suspense } from 'react';
import { ArrowRight } from 'lucide-react';
import { Heading } from '../typography/Heading';
import { Text } from '../typography/Text';
import { Link } from '../common/Link';

// Lazy load components
const CompanyLogos = lazy(() => import('../logos/CompanyLogos').then(m => ({ default: m.CompanyLogos })));
const TestimonialsSection = lazy(() => import('../testimonials/TestimonialsSection').then(m => ({ default: m.TestimonialsSection })));
const FAQ = lazy(() => import('../sections/FAQ').then(m => ({ default: m.FAQ })));
const CallToAction = lazy(() => import('../sections/CallToAction').then(m => ({ default: m.CallToAction })));

export function HomePage() {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="bg-white pt-16 pb-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Text Content */}
            <div className="text-left lg:pr-8 flex flex-col items-start">
              <Heading
                level={1}
                className="mb-6 font-bold text-4xl md:text-5xl lg:text-6xl"
              >
                Land Your Dream Job Faster With{' '}
                <span className="text-primary">
                  AI Power
                </span>
              </Heading>

              <Text
                size="lg"
                className="text-black mb-8"
              >
                Create ATS-Optimized Resume, Tailored Cover Letter, and Get Perfectly Matched Jobs - All in One Place. Your Fast Track to Dream Job Success.
              </Text>

              <Link
                href="/start"
                className="inline-flex items-center px-8 py-3 text-lg font-medium text-white bg-primary hover:bg-primary-hover transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl rounded-full"
              >
                Create Your Job Kit
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </div>

            {/* Right Column - Video */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-[90%] mx-auto">
              <div className="aspect-w-16 aspect-h-9">
                <iframe 
                  src="https://www.loom.com/embed/b4db21e1e24f4f418c7bbfdee9dc70c8?sid=6e04e86f-07d9-4f93-b6c4-a9389a13a8c2" 
                  frameBorder="0" 
                  allowFullScreen
                  className="w-full h-full rounded-2xl"
                  loading="lazy"
                  title="Product Demo Video"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lazy loaded sections */}
      <Suspense fallback={<div className="h-96 bg-white" />}>
        <TestimonialsSection />
      </Suspense>
      <Suspense fallback={<div className="h-96 bg-white" />}>
        <CompanyLogos />
      </Suspense>
      <Suspense fallback={<div className="h-96 bg-white" />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<div className="h-96 bg-white" />}>
        <CallToAction />
      </Suspense>
    </div>
  );
}